import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import moment from 'moment';

// Selectors
import { makeSelectSharedEventValue } from '../../../../services/sharedEvent/selectors';

interface Props {
    startDate: ?string;
}

export class SharedEventStartDate extends React.PureComponent<Props> {
    render() {
        const { startDate } = this.props;
        if (!startDate) return null;
        return moment(startDate, 'YYYY-MM-DD').format('MMM D');
    }
}

const mapStateToProps = createStructuredSelector({
    startDate: makeSelectSharedEventValue('startDate')
});

export default connect(mapStateToProps)(SharedEventStartDate);
